<template>
  <div id="app" class="animated fadeIn">
    <banner />
    <section class="container">
      <main-nav />
      <!-- mode="out-in" fixes jarring animation issue with components battling for DOM space -->
      <router-view v-slot="{ Component }" :key="$route.name + ($route.params.NAS_ID || $route.params._ID || '')">
        <transition
name="fade" enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster"
          mode="out-in">
          <component :is="Component" class="pb-5" />
        </transition>
      </router-view>
    </section>
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import MainNav from "@/components/MainNav.vue";

export default {
  name: "App",
  components: {
    Banner,
    MainNav
  }
};
</script>

<style lang="scss" scoped>
</style>
